import { render, staticRenderFns } from "./AuditChanges.vue?vue&type=template&id=95e98088&"
import script from "./AuditChanges.vue?vue&type=script&lang=js&"
export * from "./AuditChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports